module.exports = __webpack_public_path__ + "Step2_Header_new.059147fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step2_Header_new.png
// module id = E7E4
// module chunks = 0